<template>
  <div class="mainContainer">
    <div class="header">
      <img src="@/assets/images/Shield-user.svg" alt="Shield" />
      <span>{{ lbl['about-privacy'] }}</span>
    </div>
    <div id="pdf-wrapper">
      <div class="d-block">
        <vue-pdf-embed
          :source="term"
          style="display: inline-block; width: 100%"
        />
      </div>
      <div v-if="!isshowpdf" class="skeleton">
        <a-skeleton :loading="true" />
        <a-skeleton :loading="true" />
        <a-skeleton :loading="true" />
      </div>
    </div>
  </div>
</template>

<script>
import Account from '@/helper/AccountHelper.js'
import Mixin from '@/mixin/Mixin'
import Vue from 'vue'
import Locale from '@/helper/locale.js'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  name: 'privacy',
  mixins: [Mixin],
  components: {
    VuePdfEmbed,
  },
  data() {
    return {
      mode: 'loading',
      isshowpdf: false,
      term: null,
      currentLocale: Locale.getLocaleShort(),
    }
  },
  created() {
    Account.bzbsAnalyticTracking(
      'privacy_page',
      'privacy',
      'view_privacy',
      'on view',
    )
    this.getprivate().then(url => {
      if (url) {
        this.term = url
        this.isshowpdf = true
      } else {
        this.term = null
        this.isshowpdf = false
      }
    })
  },
  methods: {
    getprivate() {
      var filename = ''
      return new Promise(resolve => {
        if (this.currentLocale == 'th') {
          filename = 'privacyTH_TH'
        } else {
          filename = 'privacyEN_US'
        }

        var urlblob =
          Vue.bzbsConfig.bzbsBlobUrl +
          `/config/crmplus/terms-and-conditions/${filename}.pdf`
        resolve(urlblob)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.body {
  padding: 30px;
  font-size: 14px;
  color: #757575;
}
.skeleton {
  margin: 0px 20px;
}
</style>
